import { useTranslation } from "react-i18next";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import apiRequest from "../../functions/api";
import {
  TableCell,
  TableRow,
  TableBody,
  useMediaQuery,
  TableHead,
  Table,
  Paper,
  TableContainer,
  TextField,
  IconButton,
  Typography,
  enuItem,
  Button,
  Box,
  Checkbox,
  FormControlLabel,
  Tabs,
  Tab,
} from "@mui/material";

import VisibilityIcon from "@mui/icons-material/Visibility";

import InfoIcon from "@mui/icons-material/Info";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
function ExpenseMobileTable(props) {
  const { t } = useTranslation();
  //Standardfelder
  const { expenses, removeExpense, openBeleg, lock, showDetails } = props;
  const [selectedTab, setSelectedTab] = useState(0);
  const gesamtKosten =
    expenses?.length > 0
      ? expenses?.reduce(function (sum, expense) {
          if (expense.WERTE.ERGEBNIS === "") {
            return sum;
          }
          return Number(parseFloat(sum).toFixed(2)) + Number(parseFloat(expense.WERTE.ERGEBNIS).toFixed(2));
        }, 0)
      : 0 ?? 0;
  const kreditKarte =
    expenses?.length > 0
      ? expenses?.reduce(function (sum, expense) {
          if (expense.WERTE.ERGEBNIS === "") {
            return sum;
          }
          if (expense.WERTE.KREDITKARTE === true) {
            return Number(sum) + Number(parseFloat(expense.WERTE.ERGEBNIS).toFixed(2));
          } else {
            return Number(sum);
          }
        }, 0)
      : 0 ?? 0;
  useEffect(() => {
    setSelectedTab(expenses.length - 1);
  }, [expenses]);
  // expenses?.reduce((total, num) => (total + parseFloat(num.WERTE.GESAMT).toFixed(2))) : 0 ?? 0
  return (
    <>
      <Box sx={{ width: "100%" }}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <Tabs
            value={selectedTab}
            onChange={(event, newValue) => setSelectedTab(newValue)}
            variant="scrollable"
            scrollButtons="auto"
          >
            {expenses?.map((expense, count) => (
              <Tab key={count} label={t("Ausgabe ") + parseInt(count + 1)} />
            ))}
          </Tabs>
        </Box>
        {expenses[selectedTab] && (
          <div>
            <Box sx={{ display: "flex", justifyContent: "center" }}>
              <Button color="secondary" disabled={lock} onClick={() => showDetails(expenses[selectedTab], selectedTab)}>
                Bearbeiten {lock === true ? <InfoIcon /> : <EditIcon />}{" "}
              </Button>
              <Button color="secondary" disabled={lock} onClick={() => removeExpense(selectedTab)}>
                Entfernen <CloseIcon />{" "}
              </Button>
            </Box>

            <Box sx={{ p: 2}}>
              {expenses[selectedTab].WERTE.fileKey ? (
                <Button fullWidth onClick={() => openBeleg(expenses[selectedTab].WERTE, "key")}>
                 {expenses[selectedTab].WERTE.fileName} <VisibilityIcon spacing={2} />
                </Button>
              ) : expenses[selectedTab].file?.name ? (
                <Button fullWidth onClick={() => openBeleg(expenses[selectedTab], "datei")}>
                  {expenses[selectedTab]?.file.name} <VisibilityIcon spacing={2} />
                </Button>
              ) : (
                "Kein Beleg hinterlegt"
              )}
              <TextField
                disabled              
                variant="standard"
                label="Betreff"
                inputProps={{ shrink: true }}
                fullWidth
                value={expenses[selectedTab].WERTE.BETREFF?expenses[selectedTab].WERTE.BETREFF:""}
              ></TextField>
              <TextField
                disabled
                variant="standard"
                type="date"
                inputProps={{ shrink: true }}
                fullWidth
                label="Datum"
                value={expenses[selectedTab].WERTE.DATUM ? expenses[selectedTab].WERTE.DATUM : "0000-00-00"}
              ></TextField>
              <TextField
                disabled
                variant="standard"
                label="Gesamt"
                fullWidth
                value={expenses[selectedTab].WERTE.GESAMT}
              ></TextField>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled
                    checked={expenses[selectedTab].WERTE["KREDITKARTE"]}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                }
                labelPlacement=""
                label="Über Firmenkreditkarte gezahlt"
              />
              <TextField
                disabled
                variant="standard"
                label="Auszahlung"
                value={expenses[selectedTab].WERTE.AUSZAHLUNG}
              ></TextField>
            </Box>
          </div>
        )}
      </Box>
      <TableContainer>
        <Table aria-label="spanning table">
          <TableHead>
            <TableRow head>
              <TableCell align="center" colSpan={2}>
                Zusammenfassung
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell align="left">
                <Typography>{t("Gesamte Kosten")}</Typography>
              </TableCell>
              <TableCell align="center"> {parseFloat(gesamtKosten).toFixed(2)} </TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography>{t("Mit Firmenkreditkarte bezahlt")}</Typography>
              </TableCell>
              <TableCell align="center">{kreditKarte}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>
                <Typography>{t("Auszahlung")}</Typography>
              </TableCell>

              <TableCell align="center"> {parseFloat(Number(gesamtKosten) - Number(kreditKarte)).toFixed(2)}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

export default ExpenseMobileTable;
